import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.darkQuery = window.matchMedia("(prefers-color-scheme: dark)")
    this.systemThemeChanged = () => {
      if (!this.storedTheme()) this.applyTheme(this.systemTheme())
    }
    this.storageChanged = (event) => {
      if (event.key === this.storageKey()) {
        this.applyTheme(this.storedTheme() || this.systemTheme())
      }
    }

    if (this.darkQuery.addEventListener) {
      this.darkQuery.addEventListener("change", this.systemThemeChanged)
    } else {
      this.darkQuery.addListener?.(this.systemThemeChanged)
    }
    window.addEventListener("storage", this.storageChanged)
    this.applyTheme(this.currentTheme())
  }

  disconnect() {
    if (this.darkQuery?.removeEventListener) {
      this.darkQuery.removeEventListener("change", this.systemThemeChanged)
    } else {
      this.darkQuery?.removeListener?.(this.systemThemeChanged)
    }
    window.removeEventListener("storage", this.storageChanged)
  }

  toggle() {
    const theme = this.currentTheme() === "dark" ? "light" : "dark"

    try {
      window.localStorage.setItem(this.storageKey(), theme)
    } catch (_error) {
      // The in-page override still works when storage is unavailable.
    }

    this.applyTheme(theme)
  }

  currentTheme() {
    return document.documentElement.dataset.theme || this.storedTheme() || this.systemTheme()
  }

  storedTheme() {
    return window.fansiteTheme?.storedTheme?.() || null
  }

  systemTheme() {
    return window.fansiteTheme?.systemTheme?.() || (this.darkQuery?.matches ? "dark" : "light")
  }

  storageKey() {
    return window.fansiteTheme?.storageKey || "ilovemyart-theme"
  }

  applyTheme(theme) {
    const resolvedTheme = window.fansiteTheme?.apply?.(theme) || theme
    const actionLabel = resolvedTheme === "dark" ? "Use light mode" : "Use dark mode"
    const matchingControls = document.querySelectorAll?.('[data-controller~="theme-toggle"]')
    const controls = matchingControls?.length ? matchingControls : [this.element]

    controls.forEach((control) => {
      control.setAttribute("aria-label", actionLabel)
      control.setAttribute("title", actionLabel)
    })
  }
}
